const DEPLOY_MODE = "prod";

export const API_URL = DEPLOY_MODE === "dev" ? 'http://192.168.0.55:3000' : 'https://api.pressandco.fr'
export const WEBSITE_URL = DEPLOY_MODE === "dev" ? 'http://localhost:3100' : 'https://pressandco.fr'
export const ADMIN_WEBSITE_URL = DEPLOY_MODE === "dev" ? 'http://localhost:3001' : 'https://admin.pressandco.fr'

export const CENTER_LAT = 48.875873;
export const CENTER_LNG = 2.343092;
export const MAX_RADIUS = 10000;